import { render, staticRenderFns } from "./faq_flotte.vue?vue&type=template&id=5dd496e1&scoped=true"
import script from "./faq_flotte.vue?vue&type=script&lang=js"
export * from "./faq_flotte.vue?vue&type=script&lang=js"
import style0 from "./faq_flotte.vue?vue&type=style&index=0&id=5dd496e1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd496e1",
  null
  
)

export default component.exports